export const DEFAULT_BOOKINGS_PAGE_SIZE = 10
export const MINIMUM_PRICE_FOR_CANCEL_INSURANCE = 100
